import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/header";
import Footer from "../components/footer";
class CreateMeeting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <Fragment>
        <Helmet>
          <link
            href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&family=Roboto:wght@400;500&display=swap"
            rel="stylesheet"
          />
        </Helmet>
        <div
        className="page-wrapper h-100 bg-img d-flex flex-column justify-content-between"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL +
            "/assets/img/backgrounds/bg.jpg"})`
        }}
      >
        <Header />
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <h2 className="content__title">
                  Coming Soon!
                </h2>
                <div className="space-mt--10">
                 
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      </Fragment>
    );
  }
}
export default CreateMeeting;
